/**
 * NLB-GW
 *
 * Contact: service@rheinenergie.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Profile Data (up to 15 minute granularity)
 */
export interface ProfileData { 
    isProvisional?: boolean;
    cost?: number;
    consumption?: number;
}

